const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgM2EyIDIgMCAwIDEgMiAydjFoNGEyIDIgMCAwIDEgMiAydjExYTIgMiAwIDAgMS0yIDJINGEyIDIgMCAwIDEtMi0yVjhhMiAyIDAgMCAxIDItMmg0VjVhMiAyIDAgMCAxIDItMmg0em0tMyAxMkg0djRoMTZ2LTRoLTd2MWgtMnYtMXptOS03SDR2NWgxNlY4em0tNi0zaC00djFoNFY1eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg==";
export {
  I as default
};
//# sourceMappingURL=invoices-e1f8313f.mjs.map
